<template>
  <div class="loan-item">
    <div class="top-line"></div>
    <div class="preview-block" :class="{'full-desc': isFullDesc}" @click.stop="descToggle()">
      <div class="name">{{ userName }}</div>
      <div class="amount">
        <div class="title">{{ $t('message.profile.borrower.activeOffers.items.amount') }}</div>
        <div class="data">{{ item.got_money / 100 }}</div>
      </div>
      <div class="percent">
        <div class="title">{{ $t('message.profile.borrower.activeOffers.items.percent') }}</div>
        <div class="data">{{ offerPercent }}</div>
      </div>
      <div class="income">
        <div class="title">{{ $t('message.profile.borrower.activeOffers.items.income') }}</div>
        <div class="data">{{ item.must_return_money / 100 }}</div>
      </div>
      <div class="status">
        <div class="title">{{ $t('message.profile.borrower.activeOffers.items.status') }}</div>
        <div :class="item.status">
          {{ $t(`message.profile.borrower.activeOffers.status.${item.status}`) }}
        </div>
      </div>
      <div class="issued">
        <div class="title">{{ $t('message.profile.borrower.activeOffers.items.issued') }}</div>
        <div class="data">{{ offerIssuedDate }}</div>
      </div>
      <div class="term">
        <div class="title">{{ $t('message.profile.borrower.activeOffers.items.term') }}</div>
        <div class="data">{{ offerTerm }}</div>
      </div>
      <div class="issued-by">
        <div class="title">{{ $t('message.profile.borrower.activeOffers.items.issuedBy') }}</div>
        <div class="data">{{ offerIssueDate }}</div>
      </div>
      <div class="peni">
        <div class="title">{{ $t('message.profile.borrower.activeOffers.items.peni') }}</div>
        <div class="data">{{ item.total_penalty / 100 }}</div>
      </div>
      <div class="total-amount">
        <div class="title">{{ $t('message.profile.borrower.activeOffers.items.totalAmount') }}</div>
        <div class="data">{{ (item.rest_debt) / 100 }}</div>
      </div>
      <div class="btn-block">
        <base-button
          :text="$t(`message.profile.borrower.activeOffers.transactions`)"
          class="transactions-btn"
          @click="openTransactions(item.public_id)"
        />
      </div>
    </div>

    <div class="btn-block" v-if="isShowPayBtn">
      <base-button
        :text="$t(`message.profile.borrower.activeOffers.btn`)"
        class="pay-btn"
        @click="openPayModal()"
        :disabled="!profile.default_card_id"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseButton from '../../components/base/BaseButton.vue';
export default {
  name: 'MobileBorrowerLoanItem',
  props: {
    item: Object
  },
  components: {
    BaseButton
  },
  data() {
    return {
      isFullDesc: false
    }
  },
  methods: {
    descToggle() {
      this.isFullDesc = !this.isFullDesc;
    },
    openTransactions(id) {
      this.$router.push({name: 'loan', params: { id }});
    },
    openPayModal() {
      this.$emit('openPayModal', { totalAmount: this.item.rest_debt, loan_public_id: this.item.public_id })
    },
  },
  computed: {
    ...mapGetters(['profile']),
    userName() {
      const lastName = this.item?.Offer?.MsiIndividualUser?.name_ru?.family_name_ru;
      const name = (this.item?.Offer?.MsiIndividualUser?.name_ru?.given_name_ru).slice(0, 1) + '.';
      const middleName = this.item?.Offer?.MsiIndividualUser?.name_ru?.middle_name_ru.slice(0, 1) + '.';

      return `${lastName} ${name} ${middleName}`;
    },
    offerTerm() {
      return this.item?.Offer?.loan_term_days + 'д.';
    },
    offerPercent() {
      return this.item?.Offer?.annual_percent;
    },
    isShowPayBtn() {
      return this.item.status == 'current_debt' || this.item.status === 'overdue';
    },
    offerIssuedDate() {
      return new Date(this.item?.createdAt).toLocaleDateString();
    },
    offerIssueDate() {
      return new Date(this.item?.due_date).toLocaleDateString();
    },
  }
}
</script>

<style lang="scss" scoped>
.loan-item {
  width: 100%;
  padding-bottom: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  font-size: 16px;
  line-height: 135%;
  font-weight: 400;
  color: #121212;
}

.top-line {
  margin-bottom: 10px;
  width: 100%;
  height: 1px;
  background: #ECEEF0;
  border-radius: 3px;
}

.preview-block {
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 160px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.full-desc {
  height: auto;
}

.name {
  width: 100%;
  margin-bottom: 10px;
}

.amount,
.term,
.percent,
.income,
.status,
.issued,
.issued-by,
.peni,
.total-amount {
  margin-bottom: 8px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.title {
  font-size: 14px;
  line-height: 19px;
  color: #878787;
}

.payment,
.on_due,
.current_debt,
.payment_pending {
  padding: 5.5px 15px;
  box-sizing: border-box;
  color: #CB7723;
  background: #FFF1D5;
  border-radius: 6px;
  font-size: 14px;
  line-height: 19px;
}

.closed,
.paid,
.repaid {
  padding: 5.5px 15px;
  box-sizing: border-box;
  color: #21A15C;
  background: #D6F9D3;
  border-radius: 6px;
  font-size: 14px;
  line-height: 19px;
}

.expired,
.overdue {
  padding: 5.5px 15px;
  box-sizing: border-box;
  color: #C93434;
  background: #FFDBDB;
  border-radius: 6px;
  font-size: 14px;
  line-height: 19px;
}

.btn-block {
  margin-top: 20px;
  width: 100%;
  height: 38px;
}

.pay-btn ::v-deep {
  background-color: white;
  border: 2px solid #41BF7B;
  border-radius: 6px;
  color: #41BF7B;
  padding: 0;
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;

  &:hover {
    background-color: #41BF7B;
    color: white;
  }
}

.transactions-btn ::v-deep {
  border-radius: 6px;
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
}
</style>